<template>
    <div>
        <!-- Modal Motivo de Glosa -->
        <div class="modal fade" :id="modalPrefix + 'motivoGlosaModal'" tabindex="-1" role="dialog" aria-labelledby="motivoModalLabel" aria-hidden="true"
            :class="submodal ? 'modal-dialog-level-2' : ''">
            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                <div class="modal-content" v-if="guias">
                <div class="modal-header">
                    <h5 class="modal-title" id="motivoModalLabel">Adicionar Pendência</h5>
                    <button type="button" class="close" @click="fechar ()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-for="(item, index) in incluir_motivos" :key="index">

                        <div class="row">

                            <!-- Motivos Lançados -->
                            <div class="col">

                                <!-- Motivo Interno -->
                                <az-input
                                    placeholder="Motivo não selecionado..."
                                    icon="fas fa-minus"
                                    type="text" 
                                    :edicao="false"
                                    v-model="item.motivo_glosa.search"
                                    buttonText="fas fa-minus fa-fw" 
                                    :buttonIcon="true" 
                                    buttonColor="outline-danger"
                                    @clickButton="excluirMotivo(index)" />

                            </div>

                        </div>

                    </div>

                    <div class="row">

                        <!-- Novo Motivo -->
                        <div class="col">

                            <!-- Motivo Interno -->
                            <az-input
                                v-show="edicao_status == 'PR'"
                                placeholder="Selecione o motivo da pendência da recepção..."
                                icon="fas fa-plus"
                                type="autocomplete" 
                                optionsMode="aql"
                                optionsName="motivos-internos"
                                :optionsParm="{ where: { fl_interno: 1 } }"
                                service="motivos_glosa.index" 
                                :optionsSync="false"
                                v-model="novo_motivo_glosa"
                                @input="incluir ()" />

                            <!-- Motivo Externo -->
                            <az-input
                                v-show="edicao_status != 'PR'"
                                placeholder="Selecione o motivo..."
                                icon="fas fa-plus"
                                type="autocomplete" 
                                optionsMode="aql"
                                optionsName="motivos-externos"
                                :optionsParm="{ where: { fl_interno: 0 } }"
                                service="motivos_glosa.index" 
                                :optionsSync="false"
                                v-model="novo_motivo_glosa"
                                @input="incluir ()" />

                            <!-- Responsável -->
                            <div class="mt-3">
                                <az-input
                                    label="Usuário Responsável"    
                                    placeholder="Responsável pelo lançamento da guia ou Selecione o responsável..."
                                    icon="fas fa-plus"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    optionsName="usuario-responsavel"
                                    :optionsParm="{ where: { fL_ativo: 1 }, perfil: 4, nomedico: true }"
                                    service="usuarios.index" 
                                    :optionsSync="false"
                                    required 
                                    :validate="validate"
                                    v-model="novo_usuario_responsavel" />

                                <div class="list-group">
                                    <button type="button" class="list-group-item list-group-item-action" v-for="(resp, irx) in responsaveis" :key="irx" @click="novo_usuario_responsavel = resp">
                                        {{ resp.search }}
                                        <span class="ml-2 badge badge-secondary">
                                            {{ resp.st_login }}
                                        </span>
                                    </button>
                                </div>
                            </div>

                            <!-- Observação -->
                            <div class="mt-3">
                                <az-input
                                    label="Observação"    
                                    type="textarea" 
                                    rows="3"
                                    v-model="st_observacoes" />
                            </div>

                        </div>

                    </div>

                    <pre v-if="false">{{ responsaveis }}</pre>

                    <div class="my-5">
                        &nbsp;
                    </div>
                </div>
                
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar ()">Fechar</button>
                    <az-submit @click="atualizar ('pendenciar')" v-if="incluir_motivos.length">Incluir</az-submit>
                </div>
                </div>
            </div>
        </div>

        <!-- Solução das Pendências -->
        <div class="modal fade" id="solucionarMotivoGlosaModal" tabindex="-1" role="dialog" aria-labelledby="solucionarMotivoModalLabel" aria-hidden="true"
            :class="submodal ? 'modal-dialog-level-2' : ''">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content" v-if="guias">
                <div class="modal-header">
                    <h5 class="modal-title" id="motivoModalLabel">Solucionar Pendência</h5>
                    <button type="button" class="close" @click="fechar_solucao ()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-if="guias">
                    
                    <template v-if="unica">
                        <ul class="list-group mb-3">
                            <li class="list-group-item" v-for="(pend, ipx) in pendencias" :key="ipx">
                                {{ pend.motivo_glosa.search }}
                            </li>
                        </ul>
                        <pre class="alert alert-warning" v-if="1 == 0">{{ guias[0].guia_motivo_glosas }}</pre>
                    </template>

                    <template v-else>
                        <h2>{{ guias.length }} {{ guias.length > 1 ? 'guias selecionadas' : 'guia selecionada' }}</h2>
                    </template>

                    <h3 class="my-2">Confirma a solução das pendências?</h3>

                    <az-input
                        label="Observação"    
                        type="textarea" 
                        rows="3"
                        v-model="st_observacoes" />
                </div>
                
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar_solucao ()">Fechar</button>
                    <az-submit @click="atualizar ('solucionar')">Solucionar</az-submit>
                </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
import $ from 'jquery';
import AzInput from '../shared/forms/AzInput.vue';
import AzSubmit from '../util/AzSubmit.vue';

export default {
    data () { 
        return { 
            guias: null,
            motivos: [],
            incluir_motivos: [],
            novo_motivo_glosa: null,
            novo_usuario_responsavel: "", 
            st_observacoes: "", 
            edicao_status: "",
            validate: false, 
            responsaveis: [],
        }
    },

    components: { 
        AzInput,
        AzSubmit, 
    },

    props: [ 'value', 'submodal', 'status', 'modalPrefix', 'unica', 'envio' ],

    computed: { 
        pendencias: function () { 
            if ( this.guias && this.guias.length == 1 ) { 
                return this.guias[0].guia_motivo_glosas.filter(item => item.fl_ativo);
            } else { 
                return [];
            }
        }
    },

    methods: { 
        abrir (guias, status = null) {
            this.incluir_motivos = [];
            this.novo_motivo_glosa = null;
            this.novo_usuario_responsavel = "";
            this.st_observacoes = "";
            this.guias = guias;
            this.edicao_status = status ? status : this.status;
            this.responsaveis = [];

            this.$util.loadItem(this, { 
                service: 'guias',
                func: 'responsaveis',
                parms: { 
                    guias: this.guias.map(guia => { return { id_guia: guia.id_guia }; }),
                }
            })
            .then(res => { 
                this.responsaveis = res;
            });

            this.$nextTick(() => { 
                $('#' + this.modalPrefix + 'motivoGlosaModal').modal('show');
            });
        }, 
        fechar () { 
            $('#' + this.modalPrefix + 'motivoGlosaModal').modal('hide');
        },
        incluir () { 
            if ( this.novo_motivo_glosa ) { 

                this.incluir_motivos.push({
                    motivo_glosa: this.novo_motivo_glosa,
                });

                this.novo_motivo_glosa = "";
                
                this.$nextTick(() => {
                    this.novo_motivo_glosa = null;
                });

            }
            
        },
        excluirMotivo (index) { 
            this.incluir_motivos.splice(index, 1);
        },
        atualizar (acao) { 
            this.$store.commit('loading', true);

            let query = { q: [ 
                {
                    name: 'guias.' + acao,
                    id: 'pend',
                    parms: { 
                        qtd: this.guias.length,
                        guias: this.guias.map(item => { 
                            return { 
                                id_guia: item.id_guia, 
                            };
                        }),
                        incluir: this.incluir_motivos,
                        status: this.edicao_status,
                        envio: this.envio, 
                        responsavel: this.novo_usuario_responsavel,
                        obs: this.st_observacoes
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.pend.status == 200 ) { 
                        this.$emit('refresh');
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                    if ( acao == 'pendenciar' )
                        this.fechar ();
                    else
                        this.fechar_solucao ();
                });

        },
        solucionar (guias) { 
            this.incluir_motivos = [];
            this.novo_motivo_glosa = null;
            this.guias = guias;
            this.st_observacoes = "";

            this.$nextTick(() => { 
                $('#solucionarMotivoGlosaModal').modal('show');
            });
        },
        fechar_solucao () { 
            $('#solucionarMotivoGlosaModal').modal('hide');
        },

        carregar_motivos() { 
            
            if ( !this.motivos ) { 

                this.loadOptions ('motivos_glosa.index', 'motivos_glosa')
                    .then(res => { 
                        this.motivos = res;                
                    });

            }

        }


    },

    mounted () { 
        /*
        this.loadOptions ('motivos_glosa.index', 'motivos_glosa')
            .then(res => { 
                this.motivos = res;                
            });
        */
    }
}
</script>

<style scoped>
.modal-dialog-level-2 {
  z-index: 1040 !important;
}

</style>